module.exports = __webpack_public_path__ + "static/ML-f07b349b4232502a3a5b8258b64ec2c6.webm";